import { createBrowserRouter } from 'react-router-dom'
import ProtectedRoute from './components/ProtectedRoute'
import AppLayout from './components/AppLayout'
import LoginPage from './pages/LoginPages'
import CarListPage from './pages/car/CarListPage'
import CarCreatePage from './pages/car/CarCreatePage'
import CarEditPage from './pages/car/CarEditPage'
import DeviceListPage from './pages/device/DeviceListPage'
import GpsDeviceCreatePage from './pages/device/DeviceCreatePage'
import DeviceEditPage from './pages/device/DeviceEditPage'
import StationListPage from './pages/station/StationListPage'
import StationCreatePage from './pages/station/StationCreatePage'
import StationEditPage from './pages/station/StationEditPage'
import LandmarkListPage from './pages/landmark/LandmarkListPage'
import LandmarkCreatePage from './pages/landmark/LandmarkCreatePage'
import LandmarkEditPage from './pages/landmark/LandmarkEditPage'
import CarLogListPage from './pages/car/CarLogPage'

import RouteEditor from './pages/route/RouteEditor'
import RouteListPage from './pages/route/RouteListPage'
import RouteEditPage from './pages/route/RouteEditPage'
import RouteCreatePage from './pages/route/RouteCreatePage'
import UserListPage from './pages/ีีuser/UserList'



export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppLayout />,
        children: [
          { path: '/', element: <CarListPage /> },

          { path: '/cars', element: <CarListPage /> },
          { path: '/cars/create', element: <CarCreatePage /> },
          { path: '/cars/edit/:id', element: <CarEditPage /> },
          { path: '/cars/:id/logs', element: <CarLogListPage /> },

          { path: '/devices', element: <DeviceListPage /> },
          { path: '/devices/create', element: <GpsDeviceCreatePage /> },
          { path: '/devices/edit/:id', element: < DeviceEditPage/>},

          { path: '/stations', element : <StationListPage />},
          { path: '/stations/create', element: <StationCreatePage />},
          { path: '/stations/edit/:id', element: <StationEditPage />},
          
          { path: '/landmarks', element : <LandmarkListPage />},
          { path: '/landmarks/create', element : <LandmarkCreatePage />},
          { path: '/landmarks/edit/:id', element : <LandmarkEditPage />},

          {path: '/setting/users', element : <UserListPage />},
          {path: '/routes', element : <RouteListPage />},
          {path: '/routes/create', element : <RouteCreatePage />},
          {path: '/routes/edit/:id', element : <RouteEditPage />},
          {path: '/route-editor', element: <RouteEditor />}
        ]
      }
    ]
  }
])
